import {ISubuserApis} from "./ISubuserApis";
import {SUBUSER_API_PREFIX} from "../../../common/configs/configs";
import ApiUtils from "../utils/ApiUtils";

export default class SubuserApis implements ISubuserApis {
    searchPatientByUHID(uhid: string): Promise<any> {
        return ApiUtils.apiGetRequest(SUBUSER_API_PREFIX + "/subusers/by_uhid/" + uhid)
    }
}